import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { MaterialModule } from '@core/modules';
import { MultilingualService } from '@core/services';
import { SetImagePathDirective } from "@shared/directives";

@Component({
    selector: 'app-sample-card-id-dialog',
    imports: [MaterialModule, SetImagePathDirective],
    templateUrl: './sample-card-id-dialog.component.html',
    styleUrl: './sample-card-id-dialog.component.scss'
})
export class SampleCardIdDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<SampleCardIdDialogComponent>,
    public readonly multilingualService: MultilingualService
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
